// extracted by mini-css-extract-plugin
module.exports = {"motto":"Motto_motto__3Fq2R","left":"Motto_left__3m0_i","view":"Motto_view__Cet3j","right":"Motto_right__2THPo"};